export enum ChartPeriodType{
    Daily,
    Weekly,
    Monthly,
    Yearly
  }
  